
angular.module('app.controllers.tab_select', []).controller('TabSelectController',
    ['$scope','$log', function ($scope, $log) {

  'use strict';

  // Matt: Naming it AccordionController will conflict with Bootstrap, hence we need to use a name different to the standard.
  $log.debug('TabSelectController()');

  $scope.shows = [true];
  $scope.typeSelection = 0;
  $scope.oneAtATime = true;
  $scope.status = {};
}]);

